import SectionHeading from "@/components/base/SectionHeading";
import { androidSteps, androidNotes, iosSteps, iosNotes } from "@/mocks/installGuide";

export default function InstallGuide() {
  return (
    <>
      <section id="android" className="scroll-mt-24 w-full bg-background-100 py-16 md:py-24">
        <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
          <SectionHeading
            eyebrow="安卓版安装包"
            title="安卓手机安装步骤（APK）"
            desc="安卓系统安装的关键在于「允许安装未知来源应用」这一步。按下方顺序操作，通常即可一次安装成功。"
          />

          <div className="mt-12 grid grid-cols-1 lg:grid-cols-3 gap-8">
            <ol className="lg:col-span-2 space-y-4">
              {androidSteps.map((step, index) => (
                <li
                  key={step.title}
                  className="flex gap-4 bg-background-50 border border-background-200 rounded-lg p-5"
                >
                  <span className="w-9 h-9 shrink-0 rounded-md bg-primary-500 text-background-50 flex items-center justify-center text-sm font-semibold">
                    {index + 1}
                  </span>
                  <div>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950">
                      {step.title}
                    </h3>
                    <p className="mt-1.5 text-xs md:text-sm leading-relaxed text-foreground-600">
                      {step.desc}
                    </p>
                  </div>
                </li>
              ))}
            </ol>

            <aside className="lg:col-span-1">
              <div className="lg:sticky lg:top-24 bg-secondary-100 border border-secondary-200 rounded-lg p-6">
                <h3 className="flex items-center gap-2 text-base font-semibold text-secondary-900">
                  <i className="ri-lightbulb-line" aria-hidden="true"></i>
                  安卓安装提示
                </h3>
                <ul className="mt-4 space-y-3">
                  {androidNotes.map((note) => (
                    <li key={note} className="flex gap-2 text-xs md:text-sm leading-relaxed text-secondary-900/90">
                      <i className="ri-checkbox-circle-line mt-0.5 text-secondary-600" aria-hidden="true"></i>
                      <span>{note}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-5 pt-5 border-t border-secondary-200">
                  <p className="text-xs text-secondary-900/80">
                    安装包体积约 85 MB，建议在 Wi-Fi 环境下下载。
                  </p>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <section id="ios" className="scroll-mt-24 w-full bg-background-50 py-16 md:py-24">
        <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
          <SectionHeading
            eyebrow="苹果版安装包"
            title="苹果手机安装步骤（iOS）"
            desc="苹果系统对非 App Store 来源的应用有信任限制，安装后需要手动信任描述文件才能正常打开。"
          />

          <div className="mt-12 grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-1 order-2 lg:order-1">
              <div className="lg:sticky lg:top-24 bg-accent-100 border border-accent-200 rounded-lg p-6">
                <h3 className="flex items-center gap-2 text-base font-semibold text-accent-900">
                  <i className="ri-shield-keyhole-line" aria-hidden="true"></i>
                  苹果安装提示
                </h3>
                <ul className="mt-4 space-y-3">
                  {iosNotes.map((note) => (
                    <li key={note} className="flex gap-2 text-xs md:text-sm leading-relaxed text-accent-900/90">
                      <i className="ri-checkbox-circle-line mt-0.5 text-accent-600" aria-hidden="true"></i>
                      <span>{note}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-5 pt-5 border-t border-accent-200">
                  <p className="text-xs text-accent-900/80">
                    安装包体积约 110 MB，建议保持电量充足再开始安装。
                  </p>
                </div>
              </div>
            </div>

            <ol className="lg:col-span-2 order-1 lg:order-2 space-y-4">
              {iosSteps.map((step, index) => (
                <li
                  key={step.title}
                  className="flex gap-4 bg-background-100 border border-background-200 rounded-lg p-5"
                >
                  <span className="w-9 h-9 shrink-0 rounded-md bg-primary-500 text-background-50 flex items-center justify-center text-sm font-semibold">
                    {index + 1}
                  </span>
                  <div>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950">
                      {step.title}
                    </h3>
                    <p className="mt-1.5 text-xs md:text-sm leading-relaxed text-foreground-600">
                      {step.desc}
                    </p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </section>
    </>
  );
}